import styled from 'styled-components';
import { Colors } from '../../colors';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  border: ${({ $borderless }) => ($borderless ? 'none' : `1px solid ${Colors.GS500}`)};
  background: ${Colors.GS0};

  ${({ $gap }) => $gap && `gap: ${$gap}px;`}
`;
